import ImageData from '@/types/ImageData'
import ProductImage from '@/types/ProductImage'

// Preset images by id, kept for the session so that pushing the same preset
// image again (product switch, clearing the gallery) does not download it and
// call the Vision API again.
const instances: { [id: string]: PresetImage } = {}

export default class PresetImage extends ProductImage {
	protected _categories = ['special', 'measurements'] as Category
	protected _prohibitDelete = true
	protected _prohibitResetCategories = true

	// Whether object detection already ran in this session, even if it found
	// nothing
	public annotated = false

	constructor(public readonly preset: MeasurementPreset) {
		super(
			PresetImage.idFor(preset),
			preset.image,
			preset.image_path.split('/').pop() || preset.image_path
		)

		this._image = new ImageData(preset.image, undefined, true)
	}

	get isPreset() {
		return true
	}

	get disallowImageEdit() {
		return true
	}

	get presetName() {
		return this.preset.name
	}

	get presetImagePath() {
		return this.preset.image_path
	}

	get presetUrl() {
		return this.preset.nova_url
	}

	static idFor(preset: MeasurementPreset) {
		const basename = (preset.image_path.split('/').pop() || '').replace(
			/\.[^.]+$/,
			''
		)

		return `PRESET_${preset.id}_${basename}`
	}

	static isPresetId(id: unknown) {
		return typeof id === 'string' && id.startsWith('PRESET_')
	}

	static forPreset(preset: MeasurementPreset): PresetImage {
		const id = PresetImage.idFor(preset)

		if (!instances[id]) {
			instances[id] = new PresetImage(preset)
		}

		instances[id].categories = ['special', 'measurements']

		return instances[id]
	}
}
